import { GetCommonSettings } from '@themes/common/data';
import { FormatMoney as GetFormatMoney } from './money';
export const FormatMoney = (cents, format, showSign = false, showSymbol = true, symbolOnly = false, currencyCode) => {
    if (!format) {
        const settings = GetCommonSettings();
        format = settings.money_format;
    }
    return GetFormatMoney(cents, format, showSign, showSymbol, symbolOnly, currencyCode);
};
export const DisplayPrice = (price, showSign = false, showSymbol = true, symbolOnly = false, currencyCode) => {
    return FormatMoney(price * 100, undefined, showSign, showSymbol, symbolOnly, currencyCode);
};
globalThis.Shopify = globalThis.Shopify || {};
globalThis.Shopify.formatMoney = globalThis.Shopify.formatMoney || FormatMoney;
globalThis.SB = globalThis.SB || {};
globalThis.SB.formatMoney = globalThis.SB.formatMoney || FormatMoney;
